module.exports = __webpack_public_path__ + "static/media/11_avatar_male.2211618e.png";